// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/default","root":"default-m__root__1h1rO"};